import { z } from 'zod';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { Organization } from 'libs/end-to-end/src/types/organizations/organization';
import { DataRule } from 'libs/end-to-end/src/data-rules';

export const GenerateReportStateMachineInput = z.object({
  organization: Organization,
  databaseId: z.string(),
  databaseRevisionId: z.string(),
  reportId: z.string(),
  dataRules: DataRule.array(),
  rootHash: z.string(),
});

export type GenerateReportStateMachineInput = z.infer<
  typeof GenerateReportStateMachineInput
>;

export const GenerateReportControllerResult = z.object({
  reportId: z.string(),
});

export type GenerateReportControllerResult = z.infer<
  typeof GenerateReportControllerResult
>;

export const GenerateReportRequestChart = z.object({
  customVizRequest: CustomVizRequest,
  name: z.string().optional(),
  description: z.string().optional(),
});

export type GenerateReportRequestChart = z.infer<
  typeof GenerateReportRequestChart
>;

export const GenerateReportRequest = z.object({
  charts: z.array(GenerateReportRequestChart),
  title: z.string().optional(),
});

export type GenerateReportRequest = z.infer<typeof GenerateReportRequest>;

export const QueryReportControllerResult = z.object({
  reportId: z.string(),
  reportStatus: z.enum(['pending', 'processing', 'success', 'failure']),
  presignedUrl: z.string().nullable(),
});

export type QueryReportControllerResult = z.infer<
  typeof GenerateReportControllerResult
>;

export const generateReportFilename = (reportId: string) => `${reportId}.docx`;
